import { render, staticRenderFns } from "./commonCertiTab.vue?vue&type=template&id=4bf294b6&scoped=true&"
import script from "./commonCertiTab.vue?vue&type=script&lang=js&"
export * from "./commonCertiTab.vue?vue&type=script&lang=js&"
import style0 from "./commonCertiTab.vue?vue&type=style&index=0&id=4bf294b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf294b6",
  null
  
)

export default component.exports